const loaded = new Set<string>();
const inflight = new Map<string, Promise<void>>();

export function isImageCached(src: string): boolean {
  return loaded.has(src);
}

export function preloadImage(src: string): Promise<void> {
  if (loaded.has(src)) return Promise.resolve();
  if (inflight.has(src)) return inflight.get(src)!;

  const p = new Promise<void>((resolve) => {
    const img = new Image();
    img.onload = img.onerror = () => {
      loaded.add(src);
      inflight.delete(src);
      resolve();
    };
    img.src = src;
  });

  inflight.set(src, p);
  return p;
}

export function preloadImages(urls: string[]): void {
  urls.forEach(u => { if (u) preloadImage(u); });
}
